// extracted by mini-css-extract-plugin
export var FooterWrapper = "Footer-module--FooterWrapper--seOZl";
export var Grid = "Footer-module--Grid--5TVTY";
export var GridDefaultTheme = "Footer-module--GridDefaultTheme--uGRzM";
export var GridDarkTheme = "Footer-module--GridDarkTheme--Y4x-X";
export var GridItem = "Footer-module--GridItem--4G45i";
export var CopyrightContainer = "Footer-module--CopyrightContainer--1D3S7";
export var LinkButton = "Footer-module--LinkButton--mU4sq";